import { useEffect, useState } from 'react';
import axios from 'axios';
import { AnimatedBackground } from './AnimatedBackground';
import ParticulasBackground from './ParticulasBackground';
import PulsoBackground from './PulsoBackground';

// Ids usados na parametrização `sistema.login_backgrounds` (backend).
const BACKGROUNDS = ['animado', 'particulas', 'pulso'] as const;
type LoginBackgroundId = (typeof BACKGROUNDS)[number];

const sortear = (ids: readonly LoginBackgroundId[]) => ids[Math.floor(Math.random() * ids.length)];

/**
 * Sorteia um fundo ao abrir a página, restrito à lista configurada para o tenant
 * (vazia ou só com ids desconhecidos = todos).
 */
export const useLoginBackground = () => {
  const [bg, setBg] = useState<LoginBackgroundId | null>(null);

  useEffect(() => {
    let vivo = true;
    axios
      .get<{ ok: boolean; result: string[] }>('/api/login/backgrounds')
      .then(({ data }) => data.result ?? [])
      .catch(() => [] as string[])
      .then((permitidos) => {
        if (!vivo) return;
        const ids = BACKGROUNDS.filter((id) => permitidos.includes(id));
        setBg(sortear(ids.length ? ids : BACKGROUNDS));
      });
    return () => {
      vivo = false;
    };
  }, []);

  return bg;
};

export const LoginBackground = ({
  bg,
  width,
  height,
  pause,
}: {
  bg: LoginBackgroundId | null;
  width: number;
  height: number;
  pause: boolean;
}) => {
  // zIndex -1: os fundos novos vêm com 0 e cobririam o card (posicionado, sem z-index).
  switch (bg) {
    case 'animado':
      return <AnimatedBackground width={width} height={height} pause={pause} />;
    case 'particulas':
      return <ParticulasBackground style={{ zIndex: -1 }} />;
    case 'pulso':
      return <PulsoBackground style={{ zIndex: -1 }} />;
    default:
      // Enquanto a config não chega: mesmo navy dos fundos, sem flash branco.
      return <div style={{ position: 'fixed', inset: 0, zIndex: -1, background: '#02172C' }} />;
  }
};
